import { render, staticRenderFns } from "./MultDivForm.vue?vue&type=template&id=2627bf0c&scoped=true&lang=pug&"
import script from "./MultDivForm.vue?vue&type=script&lang=js&"
export * from "./MultDivForm.vue?vue&type=script&lang=js&"
import style0 from "./MultDivForm.vue?vue&type=style&index=0&id=2627bf0c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2627bf0c",
  null
  
)

export default component.exports